var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-base',{attrs:{"url":_vm.url,"columns":_vm.columns,"onUpdate":() => {},"enableSearch":true,"formInputs":_vm.formInputs,"primaryKey":"id","alertMessage":_vm.alertMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }